import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';

export default class Notes extends React.Component {
  constructor(props){
    super(props);
    this.state ={
      isActive: props.isActive
    }
  }
  doClose(e){
    e.preventDefault();
    this.props.SlideActions.toggleNotes(this.props.slideIndex,false);
  }
  render() {
    if(this.props.content.length==0){
      return false;
    }
    let contentWrapper = {
      className: cx({
        'active': this.props.isActive,
        'note-content-wrapper': true
      })
    }
    const notes =  Utils.getDangerousHtml(this.props.content);
    return (
        <div className="notes-container">
          <div {...contentWrapper}>
            <div className="slide-notes">
              <this.props.Buttons.Close onClick={ this.doClose.bind(this)} />
              <div className="notes-content" dangerouslySetInnerHTML={notes} />
            </div>
          </div>
        </div>
    );
  }
}

Notes.propTypes={
    slideIndex: React.PropTypes.number,
    icon: React.PropTypes.string,
    content: React.PropTypes.string,
    isActive: React.PropTypes.bool,
    SlideActions: React.PropTypes.object,
    Buttons: React.PropTypes.object
}
Notes.defaultProps={
  icon: '',
  content: '',
  isActive: false

}




// WEBPACK FOOTER //
// ./src/app/carousel/notes.jsx